import { observer } from 'src/utils/mobx-react';

import {
    OverlayDefault,
    Content,
    PopupHeader,
    PopupDescription,
    TermsBox,
    AcceptBtn,
    LinkWrapper,
} from 'src/domains/players/webview/components/Account/Notifications/BlockingNotifications.style';
import React from 'react';
import { I18n } from 'src/domains/layouts/webview/components/language/I18n';
import { Policy } from 'src/domains/players/webview/components/Account/resetPasswordProcedure/resetPasswordForm/Policy';
import { UniverseComponent } from 'src/domains/common/universes';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';

interface PrivacyPolicyNotificationPropsType {
    onConfirm: () => Promise<void>;
}

export const PrivacyPolicyNotification = observer(
    'PrivacyPolicyNotification',
    ({ onConfirm }: PrivacyPolicyNotificationPropsType): JSX.Element | null => {
        const common = useCommon();
        const {
            accountHelperMail,
            componentVariants: { systemPagesVariant },
        } = ConfigComponents.get(common).config;

        return (
            <OverlayDefault data-test='overlay-prompt'>
                <Content>
                    <UniverseComponent>
                        {(universeModule): React.ReactElement => <universeModule.compliancePopupLogo />}
                    </UniverseComponent>
                    <PopupHeader>
                        <I18n
                            langKey='account.updated-privacy-notification.title'
                            defaultText="We've updated our Privacy Policy"
                        />
                    </PopupHeader>
                    <PopupDescription>
                        <I18n
                            langKey='account.updated-privacy-notification.description-part-1'
                            defaultText='We are getting in touch to let you know that we have made some changes to our Privacy Policy. To continue to use your account, please accept the new Privacy Policy, which can be found below:'
                        />
                    </PopupDescription>
                    <TermsBox systemPagesVariant={systemPagesVariant}>
                        <Policy
                            leftAlign
                            id='privacy-policy'
                        />
                    </TermsBox>

                    <PopupDescription>
                        <I18n
                            langKey='account.change-privacy-notification.description-part-2'
                            defaultText='If you do not agree to the new Privacy Policy, do not click the Accept button and contact'
                        />{' '}
                        <LinkWrapper to={`mailto:${accountHelperMail}`}>
                            <I18n
                                langKey='account.deposit.info-page.email'
                                defaultText='{accountHelperMail}'
                                params={{ accountHelperMail }}
                            />
                        </LinkWrapper>
                    </PopupDescription>

                    <AcceptBtn
                        onClick={onConfirm}
                        size='medium'
                    >
                        <I18n
                            langKey='account.updated-privacy-notification.confirm-button.label'
                            defaultText='Accept'
                        />
                    </AcceptBtn>
                </Content>
            </OverlayDefault>
        );
    }
);
